var RolesModule = /** @class */ (function () {
    function RolesModule() {
    }
    return RolesModule;
}());
export { RolesModule };
